import apiService from "../../service/apiService";
import { cloneDeep } from "lodash";
import URL from "@/constants/baseurl";

export default {
    namespaced: true,
    state: () => ({
        franchisees: [],

        franchisee_filters: {
            name: '',
            page: 1,
        }

    }),
    mutations: {
        SET_FRANCHISEES(state, franchisees) {
            state.franchisees = franchisees;
        }

    },
    actions: {

        set_franchisees({ commit }, data) {
            commit('SET_FRANCHISEES', data);
        },

        async get_franchisees({ state, commit }) {
            const apiToken = localStorage.getItem('token');
            const url = `${URL.BASEURL}/api/get-franchisees`;

            let filters = {
                name: state.franchisee_filters.name,
                page: state.franchisee_filters.page,
            };

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    },
                    body: JSON.stringify(filters)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const res = await response.json();
                commit('SET_FRANCHISEES', res);
            } catch (error) {
                console.error('Error fetching franchisees:', error);
            }
        }

    },
    getters: {}
}
